// extracted by mini-css-extract-plugin
module.exports = {"upButton":"Upbutton_upButton__18S8P"};